import foolCard from "@/assets/img/cards/d_0_fool.png";
import magicianCard from "@/assets/img/cards/d_1_magician.png";
import priestessCard from "@/assets/img/cards/d_2_priestess.png";
import empressCard from "@/assets/img/cards/d_3_empress.png";
import emperorCard from "@/assets/img/cards/d_4_emperor.png";
import hierophantCard from "@/assets/img/cards/d_5_hierophant.png";
import loversCard from "@/assets/img/cards/d_6_lovers.png";
import chariotCard from "@/assets/img/cards/d_7_chariot.png";
import strengthCard from "@/assets/img/cards/d_8_strength.png";
import hermitCard from "@/assets/img/cards/d_9_hermit.png";
import wheelOfFortuneCard from "@/assets/img/cards/d_10_wheel_of_fortune.png";
import justiceCard from "@/assets/img/cards/d_11_justice.png";
import hangedManCard from "@/assets/img/cards/d_12_hanged_man.png";
import deathCard from "@/assets/img/cards/d_13_death.png";
import temperanceCard from "@/assets/img/cards/d_14_temperance.png";
import devilCard from "@/assets/img/cards/d_15_devil.png";
import towerCard from "@/assets/img/cards/d_16_tower.png";
import starCard from "@/assets/img/cards/d_17_star.png";
import moonCard from "@/assets/img/cards/d_18_moon.png";
import sunCard from "@/assets/img/cards/d_19_sun.png";
import judgementCard from "@/assets/img/cards/d_20_judgement.png";
import worldCard from "@/assets/img/cards/d_21_world.png";
import aceOfWandsCard from "@/assets/img/cards/d_wands_1_ace.png";
import aceOfSwordsCard from "@/assets/img/cards/d_swords_1_ace.png";
import aceOfPentaclesCard from "@/assets/img/cards/d_pentacles_1_ace.png";
import aceOfCupsCard from "@/assets/img/cards/d_cups_1_ace.png";
import twoOfWandsCard from "@/assets/img/cards/d_wands_2.png";
import threeOfWandsCard from "@/assets/img/cards/d_wands_3.png";
import fourOfWandsCard from "@/assets/img/cards/d_wands_4.png";
import fiveOfWandsCard from "@/assets/img/cards/d_wands_5.png";
import sixOfWandsCard from "@/assets/img/cards/d_wands_6.png";
import sevenOfWandsCard from "@/assets/img/cards/d_wands_7.png";
import eightOfWandsCard from "@/assets/img/cards/d_wands_8.png";
import nineOfWandsCard from "@/assets/img/cards/d_wands_9.png";
import tenOfWandsCard from "@/assets/img/cards/d_wands_10.png";
import pageOfWandsCard from "@/assets/img/cards/d_wands_henchman.png";
import knightOfWandsCard from "@/assets/img/cards/d_wands_knight.png";
import queenOfWandsCard from "@/assets/img/cards/d_wands_queen.png";
import kingOfWandsCard from "@/assets/img/cards/d_wands_king.png";
import twoOfSwordsCard from "@/assets/img/cards/d_swords_2.png";
import threeOfSwordsCard from "@/assets/img/cards/d_swords_3.png";
import fourOfSwordsCard from "@/assets/img/cards/d_swords_4.png";
import fiveOfSwordsCard from "@/assets/img/cards/d_swords_5.png";
import sixOfSwordsCard from "@/assets/img/cards/d_swords_6.png";
import sevenOfSwordsCard from "@/assets/img/cards/d_swords_7.png";
import eightOfSwordsCard from "@/assets/img/cards/d_swords_8.png";
import nineOfSwordsCard from "@/assets/img/cards/d_swords_9.png";
import tenOfSwordsCard from "@/assets/img/cards/d_swords_10.png";
import pageOfSwordsCard from "@/assets/img/cards/d_swords_henchman.png";
import knightOfSwordsCard from "@/assets/img/cards/d_swords_knight.png";
import queenOfSwordsCard from "@/assets/img/cards/d_swords_queen.png";
import kingOfSwordsCard from "@/assets/img/cards/d_swords_king.png";
import twoOfPentaclesCard from "@/assets/img/cards/d_pentacles_2.png";
import threeOfPentaclesCard from "@/assets/img/cards/d_pentacles_3.png";
import fourOfPentaclesCard from "@/assets/img/cards/d_pentacles_4.png";
import fiveOfPentaclesCard from "@/assets/img/cards/d_pentacles_5.png";
import sixOfPentaclesCard from "@/assets/img/cards/d_pentacles_6.png";
import sevenOfPentaclesCard from "@/assets/img/cards/d_pentacles_7.png";
import eightOfPentaclesCard from "@/assets/img/cards/d_pentacles_8.png";
import nineOfPentaclesCard from "@/assets/img/cards/d_pentacles_9.png";
import tenOfPentaclesCard from "@/assets/img/cards/d_pentacles_10.png";
import pageOfPentaclesCard from "@/assets/img/cards/d_pentacles_henchman.png";
import knightOfPentaclesCard from "@/assets/img/cards/d_pentacles_knight.png";
import queenOfPentaclesCard from "@/assets/img/cards/d_pentacles_queen.png";
import kingOfPentaclesCard from "@/assets/img/cards/d_pentacles_king.png";
import twoOfCupsCard from "@/assets/img/cards/d_cups_2.png";
import threeOfCupsCard from "@/assets/img/cards/d_cups_3.png";
import fourOfCupsCard from "@/assets/img/cards/d_cups_4.png";
import fiveOfCupsCard from "@/assets/img/cards/d_cups_5.png";
import sixOfCupsCard from "@/assets/img/cards/d_cups_6.png";
import sevenOfCupsCard from "@/assets/img/cards/d_cups_7.png";
import eightOfCupsCard from "@/assets/img/cards/d_cups_8.png";
import nineOfCupsCard from "@/assets/img/cards/d_cups_9.png";
import tenOfCupsCard from "@/assets/img/cards/d_cups_10.png";
import pageOfCupsCard from "@/assets/img/cards/d_cups_henchman.png";
import knightOfCupsCard from "@/assets/img/cards/d_cups_knight.png";
import queenOfCupsCard from "@/assets/img/cards/d_cups_queen.png";
import kingOfCupsCard from "@/assets/img/cards/d_cups_king.png";

export interface CardDomain {
  id: number;
  name: string;
  cardType: CardType;
  image: string;
}

export enum CardType {
  Fool = "fool",
  Magician = "magician",
  Priestess = "priestess",
  Empress = "empress",
  Emperor = "emperor",
  Hierophant = "hierophant",
  Lovers = "lovers",
  Chariot = "chariot",
  Strength = "strength",
  Hermit = "hermit",
  WheelOfFortune = "wheelOfFortune",
  Justice = "justice",
  HangedMan = "hangedMan",
  Death = "death",
  Temperance = "temperance",
  Devil = "devil",
  Tower = "tower",
  Star = "star",
  Moon = "moon",
  Sun = "sun",
  Judgement = "judgement",
  World = "world",
  AceOfWands = "aceofwands",
  TwoOfWands = "twoofwands",
  ThreeOfWands = "threeofwands",
  FourOfWands = "fourofwands",
  FiveOfWands = "fiveofwands",
  SixOfWands = "sixofwands",
  SevenOfWands = "sevenofwands",
  EightOfWands = "eightofwands",
  NineOfWands = "nineofwands",
  TenOfWands = "tenofwands",
  PageOfWands = "pageofwands",
  KnightOfWands = "knightofwands",
  QueenOfWands = "queenofwands",
  KingOfWands = "kingofwands",
  AceOfSwords = "aceofswords",
  TwoOfSwords = "twoofswords",
  ThreeOfSwords = "threeofswords",
  FourOfSwords = "fourofswords",
  FiveOfSwords = "fiveofswords",
  SixOfSwords = "sixofswords",
  SevenOfSwords = "sevenofswords",
  EightOfSwords = "eightofswords",
  NineOfSwords = "nineofswords",
  TenOfSwords = "tenofswords",
  PageOfSwords = "pageofswords",
  KnightOfSwords = "knightofswords",
  QueenOfSwords = "queenofswords",
  KingOfSwords = "kingofswords",
  AceOfPentacles = "aceofpentacles",
  TwoOfPentacles = "twoofpentacles",
  ThreeOfPentacles = "threeofpentacles",
  FourOfPentacles = "fourofpentacles",
  FiveOfPentacles = "fiveofpentacles",
  SixOfPentacles = "sixofpentacles",
  SevenOfPentacles = "sevenofpentacles",
  EightOfPentacles = "eightofpentacles",
  NineOfPentacles = "nineofpentacles",
  TenOfPentacles = "tenofpentacles",
  PageOfPentacles = "pageofpentacles",
  KnightOfPentacles = "knightofpentacles",
  QueenOfPentacles = "queenofpentacles",
  KingOfPentacles = "kingofpentacles",
  AceOfCups = "aceofcups",
  TwoOfCups = "twoofcups",
  ThreeOfCups = "threeofcups",
  FourOfCups = "fourofcups",
  FiveOfCups = "fiveofcups",
  SixOfCups = "sixofcups",
  SevenOfCups = "sevenofcups",
  EightOfCups = "eightofcups",
  NineOfCups = "nineofcups",
  TenOfCups = "tenofcups",
  PageOfCups = "pageofcups",
  KnightOfCups = "knightofcups",
  QueenOfCups = "queenofcups",
  KingOfCups = "kingofcups",
}

export const CARDS: CardDomain[] = [
  {
    id: 0,
    name: "Шут",
    cardType: CardType.Fool,
    image: foolCard,
  },
  {
    id: 1,
    name: "Маг",
    cardType: CardType.Magician,
    image: magicianCard,
  },
  {
    id: 2,
    name: "Жрица",
    cardType: CardType.Priestess,
    image: priestessCard,
  },
  {
    id: 3,
    name: "Императрица",
    cardType: CardType.Empress,
    image: empressCard,
  },
  {
    id: 4,
    name: "Император",
    cardType: CardType.Emperor,
    image: emperorCard,
  },
  {
    id: 5,
    name: "Верховный жрец",
    cardType: CardType.Hierophant,
    image: hierophantCard,
  },
  {
    id: 6,
    name: "Влюблённые",
    cardType: CardType.Lovers,
    image: loversCard,
  },
  {
    id: 7,
    name: "Колесница",
    cardType: CardType.Chariot,
    image: chariotCard,
  },
  {
    id: 8,
    name: "Сила",
    cardType: CardType.Strength,
    image: strengthCard,
  },
  {
    id: 9,
    name: "Отшельник",
    cardType: CardType.Hermit,
    image: hermitCard,
  },
  {
    id: 10,
    name: "Колесо фортуны",
    cardType: CardType.WheelOfFortune,
    image: wheelOfFortuneCard,
  },
  {
    id: 11,
    name: "Справедливость",
    cardType: CardType.Justice,
      image: justiceCard,
  },
  {
    id: 12,
    name: "Повешенный",
    cardType: CardType.HangedMan,
    image: hangedManCard,
  },
  {
    id: 13,
    name: "Смерть",
    cardType: CardType.Death,
    image: deathCard,
  },
  {
    id: 14,
    name: "Умеренность",
    cardType: CardType.Temperance,
    image: temperanceCard,
  },
  {
    id: 15,
    name: "Дьявол",
    cardType: CardType.Devil,
    image: devilCard,
  },
  {
    id: 16,
    name: "Башня",
    cardType: CardType.Tower,
    image: towerCard,
  },
  {
    id: 17,
    name: "Звезда",
    cardType: CardType.Star,
    image: starCard,
  },
  {
    id: 18,
    name: "Луна",
    cardType: CardType.Moon,
    image: moonCard,
  },
  {
    id: 19,
    name: "Солнце",
    cardType: CardType.Sun,
    image: sunCard,
  },
  {
    id: 20,
    name: "Провосудие",
    cardType: CardType.Judgement,
    image: judgementCard,
  },
  {
    id: 21,
    name: "Мир",
    cardType: CardType.World,
    image: worldCard,
  },
  {
    id: 22,
    name: "Туз жезлов",
    cardType: CardType.AceOfWands,
    image: aceOfWandsCard,
  },
  {
    id: 23,
    name: "Двойка жезлов",
    cardType: CardType.TwoOfWands,
    image: twoOfWandsCard,
  },
  {
    id: 24,
    name: "Тройка жезлов",
    cardType: CardType.ThreeOfWands,
    image: threeOfWandsCard,
  },
  {
    id: 25,
    name: "Четвёрка жезлов",
    cardType: CardType.FourOfWands,
    image: fourOfWandsCard,
  },
  {
    id: 26,
    name: "Пятёрка жезлов",
    cardType: CardType.FiveOfWands,
    image: fiveOfWandsCard,
  },
  {
    id: 27,
    name: "Шестёрка жезлов",
    cardType: CardType.SixOfWands,
    image: sixOfWandsCard,
  },
  {
    id: 28,
    name: "Семёрка жезлов",
    cardType: CardType.SevenOfWands,
    image: sevenOfWandsCard,
  },
  {
    id: 29,
    name: "Восьмёрка жезлов",
    cardType: CardType.EightOfWands,
    image: eightOfWandsCard,
  },
  {
    id: 30,
    name: "Девятка жезлов",
    cardType: CardType.NineOfWands,
    image: nineOfWandsCard,
  },
  {
    id: 31,
    name: "Десятка жезлов",
    cardType: CardType.TenOfWands,
    image: tenOfWandsCard,
  },
  {
    id: 32,
    name: "Паж жезлов",
    cardType: CardType.PageOfWands,
    image: pageOfWandsCard,
  },
  {
    id: 33,
    name: "Рыцарь жезлов",
    cardType: CardType.KnightOfWands,
    image: knightOfWandsCard,
  },
  {
    id: 34,
    name: "Королева жезлов",
    cardType: CardType.QueenOfWands,
    image: queenOfWandsCard,
  },
  {
    id: 35,
    name: "Король жезлов",
    cardType: CardType.KingOfWands,
    image: kingOfWandsCard,
  },
  {
    id: 36,
    name: "Туз мечей",
    cardType: CardType.AceOfSwords,
    image: aceOfSwordsCard,
  },
  {
    id: 37,
    name: "Двойка мечей",
    cardType: CardType.TwoOfSwords,
    image: twoOfSwordsCard,
  },
  {
    id: 38,
    name: "Тройка мечей",
    cardType: CardType.ThreeOfSwords,
    image: threeOfSwordsCard,
  },
  {
    id: 39,
    name: "Четвёрка мечей",
    cardType: CardType.FourOfSwords,
    image: fourOfSwordsCard,
  },
  {
    id: 40,
    name: "Пятёрка мечей",
    cardType: CardType.FiveOfSwords,
    image: fiveOfSwordsCard,
  },
  {
    id: 41,
    name: "Шестёрка мечей",
    cardType: CardType.SixOfSwords,
    image: sixOfSwordsCard,
  },
  {
    id: 42,
    name: "Семёрка мечей",
    cardType: CardType.SevenOfSwords,
    image: sevenOfSwordsCard,
  },
  {
    id: 43,
    name: "Восьмёрка мечей",
    cardType: CardType.EightOfSwords,
    image: eightOfSwordsCard,
  },
  {
    id: 44,
    name: "Девятка мечей",
    cardType: CardType.NineOfSwords,
    image: nineOfSwordsCard,
  },
  {
    id: 45,
    name: "Десятка мечей",
    cardType: CardType.TenOfSwords,
    image: tenOfSwordsCard,
  },
  {
    id: 46,
    name: "Паж мечей",
    cardType: CardType.PageOfSwords,
    image: pageOfSwordsCard,
  },
  {
    id: 47,
    name: "Рыцарь мечей",
    cardType: CardType.KnightOfSwords,
    image: knightOfSwordsCard,
  },
  {
    id: 48,
    name: "Королева мечей",
    cardType: CardType.QueenOfSwords,
    image: queenOfSwordsCard,
  },
  {
    id: 49,
    name: "Король мечей",
    cardType: CardType.KingOfSwords,
    image: kingOfSwordsCard,
  },
  {
    id: 50,
    name: "Туз пентаклей",
    cardType: CardType.AceOfPentacles,
    image: aceOfPentaclesCard,
  },
  {
    id: 51,
    name: "Двойка пентаклей",
    cardType: CardType.TwoOfPentacles,
    image: twoOfPentaclesCard,
  },
  {
    id: 52,
    name: "Тройка пентаклей",
    cardType: CardType.ThreeOfPentacles,
    image: threeOfPentaclesCard,
  },
  {
    id: 53,
    name: "Четвёрка пентаклей",
    cardType: CardType.FourOfPentacles,
    image: fourOfPentaclesCard,
  },
  {
    id: 54,
    name: "Пятёрка пентаклей",
    cardType: CardType.FiveOfPentacles,
    image: fiveOfPentaclesCard,
  },
  {
    id: 55,
    name: "Шестёрка пентаклей",
    cardType: CardType.SixOfPentacles,
    image: sixOfPentaclesCard,
  },
  {
    id: 56,
    name: "Семёрка пентаклей",
    cardType: CardType.SevenOfPentacles,
    image: sevenOfPentaclesCard,
  },
  {
    id: 57,
    name: "Восьмёрка пентаклей",
    cardType: CardType.EightOfPentacles,
    image: eightOfPentaclesCard,
  },
  {
    id: 58,
    name: "Девятка пентаклей",
    cardType: CardType.NineOfPentacles,
    image: nineOfPentaclesCard,
  },
  {
    id: 59,
    name: "Десятка пентаклей",
    cardType: CardType.TenOfPentacles,
    image: tenOfPentaclesCard,
  },
  {
    id: 60,
    name: "Паж пентаклей",
    cardType: CardType.PageOfPentacles,
    image: pageOfPentaclesCard,
  },
  {
    id: 61,
    name: "Рыцарь пентаклей",
    cardType: CardType.KnightOfPentacles,
    image: knightOfPentaclesCard,
  },
  {
    id: 62,
    name: "Королева пентаклей",
    cardType: CardType.QueenOfPentacles,
    image: queenOfPentaclesCard,
  },
  {
    id: 63,
    name: "Король пентаклей",
    cardType: CardType.KingOfPentacles,
    image: kingOfPentaclesCard,
  },
  {
    id: 64,
    name: "Туз кубков",
    cardType: CardType.AceOfCups,
    image: aceOfCupsCard,
  },
  {
    id: 65,
    name: "Двойка кубков",
    cardType: CardType.TwoOfCups,
    image: twoOfCupsCard,
  },
  {
    id: 66,
    name: "Тройка кубков",
    cardType: CardType.ThreeOfCups,
    image: threeOfCupsCard,
  },
  {
    id: 67,
    name: "Четвёрка кубков",
    cardType: CardType.FourOfCups,
    image: fourOfCupsCard,
  },
  {
    id: 68,
    name: "Пятёрка кубков",
    cardType: CardType.FiveOfCups,
    image: fiveOfCupsCard,
  },
  {
    id: 69,
    name: "Шестёрка кубков",
    cardType: CardType.SixOfCups,
    image: sixOfCupsCard,
  },
  {
    id: 70,
    name: "Семёрка кубков",
    cardType: CardType.SevenOfCups,
    image: sevenOfCupsCard,
  },
  {
    id: 71,
    name: "Восьмёрка кубков",
    cardType: CardType.EightOfCups,
    image: eightOfCupsCard,
  },
  {
    id: 72,
    name: "Девятка кубков",
    cardType: CardType.NineOfCups,
    image: nineOfCupsCard,
  },
  {
    id: 73,
    name: "Десятка кубков",
    cardType: CardType.TenOfCups,
    image: tenOfCupsCard,
  },
  {
    id: 74,
    name: "Паж кубков",
    cardType: CardType.PageOfCups,
    image: pageOfCupsCard,
  },
  {
    id: 75,
    name: "Рыцарь кубков",
    cardType: CardType.KnightOfCups,
    image: knightOfCupsCard,
  },
  {
    id: 76,
    name: "Королева кубков",
    cardType: CardType.QueenOfCups,
    image: queenOfCupsCard,
  },
  {
    id: 77,
    name: "Король кубков",
    cardType: CardType.KingOfCups,
    image: kingOfCupsCard,
  },
];

export const getCardByName = (name: string): CardDomain | null => {
  return CARDS.find((card) => card.cardType.toString() === name) ?? null;
};
